module.exports = __webpack_public_path__ + "img/phone1.e55350a0.png";